<template>
  <main class="content">
    <div class="stats-card">
      <div class="stat-item">
        <div class="num">{{ stations.length }}</div>
        <div class="label">充电站</div>
      </div>
      <div class="stat-item">
        <div class="num green">{{ totalStalls }}</div>
        <div class="label">充电桩总数</div>
      </div>
    </div>

    <template v-if="view === 'list'">
      <div class="toolbar">
        <input v-model.trim="keyword" class="search" placeholder="搜索站点名称 / 地址" />
        <button class="btn-add" @click="openAddForm">+ 添加充电站</button>
      </div>

      <div v-if="loading" class="tip">加载中…</div>
      <div v-else-if="loadError" class="tip error">
        {{ loadError }}
        <button class="retry" @click="refresh">重试</button>
      </div>
      <StationList
        v-else
        :stations="filteredStations"
      />
    </template>

    <StationForm
      v-else
      @save="onSave"
      @cancel="view = 'list'"
    />
  </main>
</template>

<script>
import StationList from '../components/StationList.vue'
import StationForm from '../components/StationForm.vue'
import { listStations, addStation } from '../data/stations'

export default {
  name: 'HomeView',
  components: { StationList, StationForm },
  data() {
    return {
      stations: [],
      keyword: '',
      view: 'list', // list | add
      formOpenedAt: 0,
      loading: true,
      loadError: ''
    }
  },
  computed: {
    filteredStations() {
      const kw = this.keyword.toLowerCase()
      if (!kw) return this.stations
      return this.stations.filter(
        s => s.name.toLowerCase().includes(kw) || s.address.toLowerCase().includes(kw)
      )
    },
    totalStalls() {
      return this.stations.reduce((sum, s) => sum + (Number(s.totalStalls) || 0), 0)
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    openAddForm() {
      // 记录打开时间，用于提交时检查填写时长
      this.formOpenedAt = Date.now()
      this.view = 'add'
    },
    async refresh() {
      this.loading = true
      this.loadError = ''
      try {
        this.stations = await listStations()
      } catch (e) {
        this.loadError = e.message
      } finally {
        this.loading = false
      }
    },
    async onSave(form) {
      // 按人类正常输入速度限制：打开表单不足 15 秒不允许提交
      if (Date.now() - this.formOpenedAt < 15000) {
        window.alert('填写时间过短，请核对站点信息后再提交')
        return
      }
      try {
        const st = await addStation(form)
        this.stations.push(st)
        this.view = 'list'
      } catch (e) {
        window.alert(e.message)
      }
    }
  }
}
</script>
